import { TextBlock } from '../../../Atoms/Text';
import { ConfirmDialog } from '../ConfirmDialog';

export interface StepProgress {
  answered: number;
  required: number;
  // What is counted; a step's required questions unless it says otherwise.
  item?: 'question' | 'function';
}

const WORDING = {
  question: {
    left: (n: number) => `${n} required question${n === 1 ? '' : 's'} left unanswered`,
    saved: 'your answers are saved automatically',
    done: (answered: number, required: number) => `${answered} of ${required} required questions answered in this step`
  },
  function: {
    left: (n: number) => `${n} function${n === 1 ? '' : 's'} left unrated`,
    saved: 'your ratings are saved automatically',
    done: (answered: number, required: number) => `${answered} of ${required} functions rated across every supplier`
  }
};

export interface LeaveStepDialogProps {
  open: boolean;
  stepName: string;
  destinationName: string;
  progress: StepProgress;
  onStay: () => void;
  onContinue: () => void;
}

export const LeaveStepDialog = ({
  open,
  stepName,
  destinationName,
  progress,
  onStay,
  onContinue
}: LeaveStepDialogProps) => {
  const unanswered = progress.required - progress.answered;
  const wording = WORDING[progress.item ?? 'question'];
  return (
    <ConfirmDialog
      open={open}
      title={`Continue without finishing ${stepName}?`}
      message={
        `${stepName} has ${wording.left(unanswered)}. ` +
        `You can continue to ${destinationName} now — ${wording.saved}, ` +
        'so you can pick this back up anytime.'
      }
      cancelLabel="Stay and finish"
      confirmLabel="Continue Anyway"
      confirmColor="primary"
      onCancel={onStay}
      onConfirm={onContinue}>
      <TextBlock
        size="sm14"
        color="grey6"
        className="mt-3">
        {wording.done(progress.answered, progress.required)}
      </TextBlock>
    </ConfirmDialog>
  );
};

// A step with no counts yet has nothing required to finish.
export const hasUnansweredRequired = (progress?: StepProgress): progress is StepProgress =>
  !!progress && progress.answered < progress.required;
